var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: { margin: "0px 20px 0px 20px" },
          attrs: { slot: "formcontent" },
          slot: "formcontent",
        },
        [
          _c(
            "b-row",
            { staticClass: "panel-heading" },
            [
              _c(
                "b-col",
                { staticClass: "formTitleBlock", attrs: { cols: "12" } },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "content-block labelAccordionForm",
                      style: "color: " + _vm.titleColor,
                    },
                    [
                      _c("i", {
                        staticClass: "fa-light fa-file-code mr-2",
                        staticStyle: { "font-size": "20px" },
                      }),
                      _vm._v(" "),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("attachments.invc_gen")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "content-block italicMandatoryIndication text-right",
                  attrs: { cols: "12" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.asterisk_obligation_label")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.formsSubTitle.invoice_type_e"),
                hasDatePicker: "",
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6", lg: "6" } },
                    [
                      _c(
                        "label",
                        { staticStyle: { width: "10cm !important" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("common.slct_elec_invoice")) +
                              " "
                          ),
                          _c("span", { staticClass: "color-red" }, [
                            _vm._v("* "),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { list: "list-format" },
                        model: {
                          value: _vm.invoiceFormat,
                          callback: function ($$v) {
                            _vm.invoiceFormat = $$v
                          },
                          expression: "invoiceFormat",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-datalist", {
                        attrs: {
                          id: "list-format",
                          options: _vm.sortFormatsList,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.formsSubTitle.item_info_DM"),
                hasDatePicker: "",
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6", lg: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.invoice_reference"),
                        },
                        model: {
                          value: _vm.invoiceRef,
                          callback: function ($$v) {
                            _vm.invoiceRef = $$v
                          },
                          expression: "invoiceRef",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "6", lg: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        staticStyle: { width: "100% !important" },
                        attrs: {
                          isMandatory: "",
                          disablePastDates: "",
                          inputType: "date",
                          inputLabel: _vm.$t("common.exec_date_pay"),
                        },
                        model: {
                          value: _vm.dateExec,
                          callback: function ($$v) {
                            _vm.dateExec = $$v
                          },
                          expression: "dateExec",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.formsSubTitle.my_acc_info"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("select-bank-account", {
                        attrs: { value: _vm.sellerIBAN },
                        model: {
                          value: _vm.sellerIBAN,
                          callback: function ($$v) {
                            _vm.sellerIBAN = $$v
                          },
                          expression: "sellerIBAN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.formsSubTitle.item_info_b"),
                isTitleUpperCase: false,
              },
            },
            [
              _vm.contactSearch
                ? _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-contact-dropdown-label-input", {
                            attrs: { inputLabel: _vm.$t("common.chse_b") },
                            on: {
                              "change-contact": function ($event) {
                                return _vm.selectBuyer($event)
                              },
                            },
                            model: {
                              value: _vm.contactName,
                              callback: function ($$v) {
                                _vm.contactName = $$v
                              },
                              expression: "contactName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.name_social_reason"),
                        },
                        model: {
                          value: _vm.buyerName,
                          callback: function ($$v) {
                            _vm.buyerName = $$v
                          },
                          expression: "buyerName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.eml"),
                        },
                        model: {
                          value: _vm.buyerEmail,
                          callback: function ($$v) {
                            _vm.buyerEmail = $$v
                          },
                          expression: "buyerEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isCompanyContact
                ? _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: { inputLabel: _vm.$t("common.srn") },
                            model: {
                              value: _vm.buyerSiren,
                              callback: function ($$v) {
                                _vm.buyerSiren = $$v
                              },
                              expression: "buyerSiren",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: { inputLabel: _vm.$t("vat_id_nb") },
                            model: {
                              value: _vm.buyerTva,
                              callback: function ($$v) {
                                _vm.buyerTva = $$v
                              },
                              expression: "buyerTva",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: { inputLabel: _vm.$t("common.adrs") },
                        model: {
                          value: _vm.buyerAddress,
                          callback: function ($$v) {
                            _vm.buyerAddress = $$v
                          },
                          expression: "buyerAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: { inputLabel: _vm.$t("common.zp_code") },
                        model: {
                          value: _vm.buyerZip,
                          callback: function ($$v) {
                            _vm.buyerZip = $$v
                          },
                          expression: "buyerZip",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: { inputLabel: _vm.$t("common.cty") },
                        model: {
                          value: _vm.buyerCity,
                          callback: function ($$v) {
                            _vm.buyerCity = $$v
                          },
                          expression: "buyerCity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: { inputLabel: _vm.$t("common.cntry") },
                        model: {
                          value: _vm.buyerCountry,
                          callback: function ($$v) {
                            _vm.buyerCountry = $$v
                          },
                          expression: "buyerCountry",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.formsSubTitle.item_info_b_b"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "div",
                [
                  _c("b-row", { staticStyle: { "padding-left": "15px" } }, [
                    _c("label", [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.fill_in_invoice_produit"))
                      ),
                      _c("span", { staticClass: "color-red" }, [_vm._v("* ")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._l(_vm.products, function (product, index) {
                    return _c(
                      "b-row",
                      { key: index, staticClass: "form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "3" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputLabel: _vm.$t("common.desc"),
                              },
                              model: {
                                value: product.Desc,
                                callback: function ($$v) {
                                  _vm.$set(product, "Desc", $$v)
                                },
                                expression: "product.Desc",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "3" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputType: "number",
                                inputLabel: _vm.$t("common.qtty"),
                              },
                              model: {
                                value: product.Qte,
                                callback: function ($$v) {
                                  _vm.$set(product, "Qte", $$v)
                                },
                                expression: "product.Qte",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "3" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputType: "number",
                                inputLabel: _vm.$t("common.total_price"),
                              },
                              on: {
                                blur: function ($event) {
                                  product.Amount = Number(product.Amount)
                                    ? Number(product.Amount).toFixed(2)
                                    : ""
                                },
                              },
                              model: {
                                value: product.Amount,
                                callback: function ($$v) {
                                  _vm.$set(product, "Amount", $$v)
                                },
                                expression: "product.Amount",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "col-1 fa fa-times-circle text-danger",
                          staticStyle: {
                            "font-size": "25px",
                            "margin-top": "30px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeProduct(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c("b-col", { attrs: { sm: "6" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addProduct()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-circle-plus",
                              attrs: { size: "17px" },
                            }),
                            _vm._v(" "),
                            _c(
                              "i",
                              {
                                staticStyle: {
                                  color: "gray",
                                  "margin-left": "10px",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("common.add_produit")) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputValue: _vm.calculatedAmountHT,
                              isMandatory: "",
                              inputType: "number",
                              inputLabel: _vm.$t("common.amountHT"),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputType: "number",
                              inputLabel: _vm.$t("common.amountTVA"),
                            },
                            on: {
                              blur: function ($event) {
                                _vm.amountTVA = Number(_vm.amountTVA)
                                  ? Number(_vm.amountTVA).toFixed(2)
                                  : ""
                              },
                            },
                            model: {
                              value: _vm.amountTVA,
                              callback: function ($$v) {
                                _vm.amountTVA = $$v
                              },
                              expression: "amountTVA",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputValue: _vm.calculatedAmountTTC,
                              isMandatory: "",
                              inputType: "number",
                              inputLabel: _vm.$t("common.amountTTC"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-end" },
        [
          _c(
            "b-col",
            { attrs: { lg: "2", cols: "4" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "lg" },
                  on: {
                    click: function ($event) {
                      return _vm.$parent.$emit("close")
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa-light fa-circle-xmark",
                    attrs: { size: "17px" },
                  }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.cncl")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "2", cols: "4" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    size: "lg",
                    disabled: !_vm.canGenerate,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeAndGenerateInvoice()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa-light fa-file",
                    attrs: { size: "17px" },
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.generate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }